import { Divider, List } from '@mui/material'
import { useInventory } from 'features/Inventories/queries/useInventory'
import { Fragment } from 'react'
import { BoundariesListItem } from './BoundariesListItem'

type BoundariesListProps = {
  inventoryId: string
}

export const BoundariesList = ({ inventoryId }: BoundariesListProps) => {
  const { data: inventory } = useInventory(inventoryId)

  const displayingList = !!inventory?.item.boundaries.length

  return (
    <List
      sx={{
        width: '100%',
        maxWidth: 360,
        bgcolor: 'background.paper',
        paddingBlock: displayingList ? 1 : 0,
      }}
    >
      {inventory?.item.boundaries.map((boundary, index) => (
        <Fragment key={boundary.boundaryId}>
          {index > 0 && <Divider />}
          <BoundariesListItem boundary={boundary} />
        </Fragment>
      ))}
    </List>
  )
}
